//////LIBRARY//////
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { bindActionCreators } from 'redux'
import { cloneDeep, isUndefined, find, isNumber, isEmpty } from 'lodash'
//////COMPONENTS//////
import Button from '../../components/Ui/Buttons'
import ImgButton from '../../components/Ui/ImgButton'
import Theme from '../../theme/theme'
import Tooltip from '../../components/Tooltip/Tooltip'
import { initKioskCreationBankDetailsActionCreators } from '../../store/actions'
import { PageWrapperLinks, InputWrapper, LabelText, InputLogin, ErrorInputMsg } from '../../theme/GlobalCss'
import userPrivileges from '../../constants/PrivilegesList'
import { uriList } from '../../routings/settings/RouteList'
//////ASSETS//////
import Save from '../../assets/icones/global/save.svg'
import ImgClose from '../../assets/icones/global/close-white.svg'
import Info from '../../assets/icones/global/info-big-blue.svg'
import ArrowWhiteRight from '../../assets/icones/global/arrow-white-right.svg'

//////STYLED//////
const KioskBankDetailsWrapper = styled.div`
	height: 1134px;
	position: relative;
`
const KioskBankDetailTitleWrapper = styled.div`
	grid-area: title;
	display: flex;
	align-items: center;
`
const KioskBankDetailButtonWrapper = styled.div`
	grid-area: button;
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
`
const KioskBankDetailInfosWrapper = styled.div``

const FormWrapper = styled.form`
	display: grid;
	grid-template-rows: 70px 1fr 1fr;
	grid-template-columns: 2fr 1fr;
	grid-template-areas:
		'title button'
		'infosLeft infosRight'
		'formLeft formRight';
`
const KioskBankDetailColumnWrapper = styled.div`
	grid-area: formLeft;
	max-width: 1137px;
	display: grid;
	margin-top: 15px;
	grid-template-columns: repeat(3, 1fr);
	height: 60%;
	grid-template-areas: 'left middle right';
`
const Title = styled.div`
	color: ${Theme.colors.primary};
	font-weight: bold;
	margin-left: 20px;
`
const InfosContent = styled.div`
	max-width: 1134px;
	background-color: ${Theme.bankDetail.infoBackground};
	border: 1px solid ${Theme.bankDetail.infoBorder};
	& > p:last-child {
		margin-left: 37px;
		margin-bottom: 50px;
	}
`
const InfosTitle = styled.div`
	color: ${Theme.colors.primary};
	display: flex;
	align-items: center;
	margin-top: 15px;
	margin-bottom: 20px;
	& > img {
		margin-right: 15px;
		margin-left: 15px;
	}
`
const InfosFirstPart = styled.div`
	margin-left: 37px;
`
const InfosWarning = styled.div`
	color: ${Theme.colors.error};
	font-weight: bold;
	margin-left: 37px;
	margin-top: 45px;
`
const FormWrapperLeft = styled.div`
	grid-area: left;
	border-right: 1px solid ${Theme.bankDetail.border};
`
const FormWrapperMiddle = styled.div`
	grid-area: middle;
	border-right: 1px solid ${Theme.bankDetail.border};
`
const FormWrapperRight = styled.div`
	grid-area: right;
	border-right: 1px solid ${Theme.bankDetail.border};
`
const FormTitle = styled.div`
	background-color: ${Theme.colors.primary};
	width: 368px;
	height: 33px;
	color: ${Theme.bankDetail.white};
	text-align: left;
	margin-bottom: 11px;
	margin-left: 5px;
	margin-right: 4px;
	& > p {
		margin-left: 14px;
		line-height: 32px;
		margin-top: 0;
	}
`
const FormBody = styled.div`
	margin-bottom: 11px;
	margin-left: 11px;
`
const PageWrapperLinksCustom = styled(PageWrapperLinks)`
	top: ${(props) => (props.rafterDisplayed ? '-130px' : '-90px')};
`
//////STYLED//////

const KioskBankDetails = () => {
	const { translations, userRolePrivileges, initKioskCreationForm, initKioskCreation, globalLoading } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			userKioskPerimeter: state.user.identity.kioskSelected,
			userRolePrivileges: state.user.identity.rolePrivileges,
			initKioskCreation: state.initKioskCreation,
			initKioskCreationBank: state.initKioskCreation.bankDetails,
			initKioskCreationForm: state.initKioskCreation.bankDetails.data,
			initKioskCreationEditable: state.initKioskCreation.bankDetails.data.progressInfo?.editable,
			globalLoading: state.globalLoading,
		}),
		shallowEqual
	)

	const location = useLocation()

	const [stateDefaultValues, setStateDefaultValues] = useState({
		name: '',
		address: '',
		postalCode: '',
		phoneNumber: '',
		city: '',
		supportPhone: '',
		//WITH CONTACT
		withContactMerchantNumber: '',
		withContactBankCode: '',
		withContactCenterNumber: '',
		withContactSetPad: '',
		withContactRank: '',
		// WITHOUT CONTACT
		merchantNumber: '',
		bankCode: '',
		centerNumber: '',
		setPad: '',
		rank: '',
	})

	const actionsBankDetail = bindActionCreators(initKioskCreationBankDetailsActionCreators, useDispatch())

	let history = useHistory()

	const { register, handleSubmit, errors, setValue } = useForm({
		defaultValues: stateDefaultValues,
	})

	const match = useRouteMatch()

	const [isEditable, setIsEditable] = useState(false)

	///////////////////////////////HANDLER ////////////////////////////////////////

	const handleRedirect = () => {
		!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[32])) &&
			history.push(`${uriList.initKiosks}${uriList.initKioskBusinessManager}`)

		!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[33])) &&
			history.push(`${uriList.initKiosks}${uriList.initKioskCustomerManager}`)
	}

	const onSubmit = (data, e) => {
		const datas = {
			name: data.name,
			address: data.address,
			postalCode: data.postalCode,
			city: data.city,
			supportPhone: data.supportPhone,
			contractWithContact: {
				customerNumber: data.withContactMerchantNumber,
				bankCode: data.withContactBankCode,
				ipAddress: data.withContactCenterNumber,
				padSettingNumber: data.withContactSetPad,
				rank: data.withContactRank,
			},
			contractWithoutContact: {
				customerNumber: data.merchantNumber,
				bankCode: data.bankCode,
				ipAddress: data.centerNumber,
				padSettingNumber: data.setPad,
				rank: data.rank,
			},
		}

		const initKioskCreationCp = cloneDeep(initKioskCreation)
		const choice = e?.nativeEvent?.submitter?.id
		const pathName = location.pathname

		if (choice === 'continue') {
			actionsBankDetail.putContinueBankDetails(
				datas,
				pathName.indexOf(uriList.initKioskCustomerManager) === -1 ? '' : 'customer',
				initKioskCreationCp.requestId
			)
		} else if (choice === 'save') {
			actionsBankDetail.putSaveBankDetails(datas, initKioskCreationCp.requestId)
		}
	}

	///////////////////////////////USE EFFECT//////////////////////////////////////

	useEffect(() => {
		const formValues = cloneDeep(initKioskCreationForm)
		if (!isUndefined(initKioskCreationForm)) {
			setValue('name', formValues.name)
			setValue('address', formValues.address)
			setValue('postalCode', formValues.postalCode)
			setValue('city', formValues.city)
			setValue('supportPhone', formValues.supportPhone)
			setValue('withContactMerchantNumber', formValues.contractWithContact?.customerNumber)
			setValue('withContactBankCode', formValues.contractWithContact?.bankCode)
			setValue('withContactCenterNumber', formValues.contractWithContact?.ipAddress)
			setValue('withContactSetPad', formValues.contractWithContact?.padSettingNumber)
			setValue('withContactRank', formValues.contractWithContact?.rank)
			setValue('merchantNumber', formValues.contractWithoutContact?.customerNumber)
			setValue('bankCode', formValues.contractWithoutContact?.bankCode)
			setValue('centerNumber', formValues.contractWithoutContact?.ipAddress)
			setValue('setPad', formValues.contractWithoutContact?.padSettingNumber)
			setValue('rank', formValues.contractWithoutContact?.rank)

			// Disable fields if we are coming from "View" action, or by charging request with URL address
			let editable = true
			if (initKioskCreation.forceReadOnly) {
				editable = false
			} else {
				editable = formValues?.progressInfo?.editable
			}
			setIsEditable(editable)
		}
	}, [initKioskCreationForm])

	const [authorized, setAuthorized] = useState(false)

	useEffect(() => {
		return function cleanUp() {
			actionsBankDetail.resetBanqDetails()
		}
	}, [])

	useEffect(() => {
		if (!authorized && globalLoading.count === 0) {
			setAuthorized(true)
		}
	}, [globalLoading.count])

	useEffect(() => {
		if (isEmpty(translations)) return
		if (authorized) {
			if (!isUndefined(match.params.id)) {
				actionsBankDetail.getKioskCreationBank(parseInt(match.params.id))
			}
		}
	}, [authorized, translations])

	// to replace \n by <br> inside trad key and force text wrap
	const reg = new RegExp('\\\\n', 'g')
	const textTop = translations['page__initKiosk__kioskCreation__bankInformations__infoBlock_content']
	const textReplaceTop = textTop?.replace(reg, '<br>')

	const textBottom = translations['page__initKiosk__kioskCreation__bankInformations__infoBlock_warning_content']
	const textRemplaceBottom = textBottom?.replace(reg, '<br>')

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<KioskBankDetailsWrapper>
			<PageWrapperLinksCustom rafterDisplayed={initKioskCreation.statusId >= 6 ? true : false}>
				<Button
					goBack
					weight="bold"
					//actionHandler={ () => {history.push(`${uriList.users}${uriList.usersManager}`)} }
					actionHandler={() => handleRedirect()}
					text={translations['common__text__previousPage']}
				/>
			</PageWrapperLinksCustom>

			<FormWrapper onSubmit={handleSubmit(onSubmit)}>
				<KioskBankDetailTitleWrapper>
					<Title>{translations['page__initKiosk__kioskCreation_bankInformations_title']}</Title>
				</KioskBankDetailTitleWrapper>
				<KioskBankDetailButtonWrapper>
					<Tooltip tooltipId={'kioskBankDetailSave'} translationsKey={'tooltip__admin__initKiosk__kioskCreate__bankInformations_save'}>
						<ImgButton
							id={'save'}
							type="submit"
							marginRight={10}
							img={Save}
							hover={Theme.colors.hoverPrimary}
							disabled={!isEditable}
						></ImgButton>
					</Tooltip>
					<Tooltip tooltipId={'kioskBankDetailCancel'} translationsKey={'tooltip__admin__initKiosk__kioskCreate__bankInformations_cancel'}>
						<ImgButton
							action={() => handleRedirect()}
							marginRight={10}
							img={ImgClose}
							bcg={Theme.colors.error}
							hover={Theme.colors.hoverError}
						></ImgButton>
					</Tooltip>
					<Button
						weight="bold"
						type="submit"
						text={translations['page__initKiosk__common__action_nextStep']}
						id={'continue'}
						bgColor={Theme.colors.validation}
						img={ArrowWhiteRight}
						width={208}
						height={32}
						noHash
						disabled={!isEditable}
						imgLeftMgin={'11px'}
						imgMgin={'11px'}
					/>
				</KioskBankDetailButtonWrapper>
				<KioskBankDetailInfosWrapper>
					<InfosContent>
						<InfosTitle>
							<img src={Info}></img>
							<p>{translations['page__initKiosk__kioskCreation__bankInformations__infoBlock_title']}</p>
						</InfosTitle>
						<InfosFirstPart dangerouslySetInnerHTML={{ __html: textReplaceTop }} />
						<InfosWarning>{translations['page__initKiosk__kioskCreation__bankInformations__infoBlock_warning_title']} :</InfosWarning>
						<p dangerouslySetInnerHTML={{ __html: textRemplaceBottom }}></p>
					</InfosContent>
				</KioskBankDetailInfosWrapper>
				<KioskBankDetailColumnWrapper>
					<FormWrapperLeft>
						<FormTitle>
							<p>{translations['page__initKiosk__kioskCreation__bankInformations__bankDomiciliation_title']}</p>
						</FormTitle>
						<FormBody>
							{/* Enseigne */}
							<LabelText>{`${translations['page__initKiosk__kioskCreation__bankInformations__bankDomiciliation_name']}`} :</LabelText>
							<InputWrapper margin={22}>
								<InputLogin
									name="name"
									width={270}
									type="text"
									disabled={!isEditable}
									ref={register({
										maxLength: {
											value: 250,
											message: '',
										},
									})}
									placeholder={translations['page__initKiosk__kioskCreation__bankInformations__bankDomiciliation_name_placeHolder']}
								/>
								{errors.name && <ErrorInputMsg>{errors.name.message}</ErrorInputMsg>}
							</InputWrapper>
							{/* Adresse Banque */}
							<LabelText>
								{`${translations['page__initKiosk__kioskCreation__bankInformations__bankDomiciliation_address']}`} :
							</LabelText>
							<InputWrapper margin={22}>
								<InputLogin
									name="address"
									width={270}
									type="text"
									disabled={!isEditable}
									ref={register({
										maxLength: {
											value: 250,
											message: '',
										},
									})}
									placeholder={
										translations['page__initKiosk__kioskCreation__bankInformations__bankDomiciliation_address_placeHolder']
									}
								/>
								{errors.address && <ErrorInputMsg>{errors.address.message}</ErrorInputMsg>}
							</InputWrapper>
							{/* Code Postal */}
							<LabelText>
								{`${translations['page__initKiosk__kioskCreation__bankInformations__bankDomiciliation_postalCode']}`} :
							</LabelText>
							<InputWrapper margin={22}>
								<InputLogin
									name="postalCode"
									width={270}
									type="text"
									disabled={!isEditable}
									ref={register({
										maxLength: {
											value: 150,
											message: '',
										},
									})}
									placeholder={
										translations['page__initKiosk__kioskCreation__bankInformations__bankDomiciliation_postalCode_placeHolder']
									}
								/>
								{errors.postalCode && <ErrorInputMsg>{errors.postalCode.message}</ErrorInputMsg>}
							</InputWrapper>
							{/* Ville de la Banque */}
							<LabelText>{`${translations['page__initKiosk__kioskCreation__bankInformations__bankDomiciliation_city']}`} :</LabelText>
							<InputWrapper margin={22}>
								<InputLogin
									name="city"
									width={270}
									type="text"
									disabled={!isEditable}
									ref={register({
										maxLength: {
											value: 250,
											message: '',
										},
									})}
									placeholder={translations['page__initKiosk__kioskCreation__bankInformations__bankDomiciliation_city_placeHolder']}
								/>
								{errors.city && <ErrorInputMsg>{errors.city.message}</ErrorInputMsg>}
							</InputWrapper>
							{/* Téléphone Assistance Monétique*/}
							<LabelText>
								{`${translations['page__initKiosk__kioskCreation__bankInformations__bankDomiciliation_supportPhone']}`} :
							</LabelText>
							<InputWrapper margin={22}>
								<InputLogin
									name="supportPhone"
									width={270}
									type="text"
									disabled={!isEditable}
									ref={register({
										maxLength: {
											value: 150,
											message: '',
										},
										pattern: {
											message: translations['common__text__positiveInteger'],
											value: /(?<=\s|^)\d+(?=\s|$)/,
										},
										validate: (value) => isNumber(parseInt(value)),
									})}
									placeholder={
										translations['page__initKiosk__kioskCreation__bankInformations__bankDomiciliation_supportPhone_placeHolder']
									}
								/>
								{errors.supportPhone && <ErrorInputMsg>{errors.supportPhone.message}</ErrorInputMsg>}
							</InputWrapper>
						</FormBody>
					</FormWrapperLeft>
					<FormWrapperMiddle>
						<FormTitle>
							<p>{translations['page__initKiosk__kioskCreation__bankInformations__automateWithContact_title']}</p>
						</FormTitle>
						<FormBody>
							{/* Numéro commerçant */}
							<LabelText>
								{`${translations['page__initKiosk__kioskCreation__bankInformations__automateWithContact_customerPo']}`} :
							</LabelText>
							<InputWrapper margin={22}>
								<InputLogin
									name="withContactMerchantNumber"
									width={270}
									type="text"
									disabled={!isEditable}
									ref={register({
										maxLength: {
											value: 250,
											message: '',
										},
										minLength: {
											value: 7,
											message: `7 ${translations['common__text__charMin']}`,
										},
									})}
									placeholder={
										translations['page__initKiosk__kioskCreation__bankInformations__automateWithContact_customerPo_placeHolder']
									}
								/>
								{errors.withContactMerchantNumber && <ErrorInputMsg>{errors.withContactMerchantNumber.message}</ErrorInputMsg>}
							</InputWrapper>
							{/* Code Banque */}
							<LabelText>
								{`${translations['page__initKiosk__kioskCreation__bankInformations__automateWithContact_bankCode']}`} :
							</LabelText>
							<InputWrapper margin={22}>
								<InputLogin
									name="withContactBankCode"
									width={270}
									type="text"
									disabled={!isEditable}
									ref={register({
										maxLength: {
											value: 250,
											message: '',
										},
									})}
									placeholder={
										translations['page__initKiosk__kioskCreation__bankInformations__automateWithContact_bankCode_placeHolder']
									}
								/>
								{errors.withContactBankCode && <ErrorInputMsg>{errors.withContactBankCode.message}</ErrorInputMsg>}
							</InputWrapper>
							{/* Numéro de Centre */}
							<LabelText>
								{`${translations['page__initKiosk__kioskCreation__bankInformations__automateWithContact_ipAddress']}`} :
							</LabelText>
							<InputWrapper margin={22}>
								<InputLogin
									name="withContactCenterNumber"
									width={270}
									type="text"
									disabled={!isEditable}
									ref={register({
										maxLength: {
											value: 250,
											message: '',
										},
									})}
									placeholder={
										translations['page__initKiosk__kioskCreation__bankInformations__automateWithContact_ipAddress_placeHolder']
									}
								/>
								{errors.withContactCenterNumber && <ErrorInputMsg>{errors.withContactCenterNumber.message}</ErrorInputMsg>}
								{/* PAD de Paramétrage */}
							</InputWrapper>
							<LabelText>
								{`${translations['page__initKiosk__kioskCreation__bankInformations__automateWithContact_padSetting']}`} :
							</LabelText>
							<InputWrapper margin={22}>
								<InputLogin
									name="withContactSetPad"
									width={270}
									type="text"
									disabled={!isEditable}
									ref={register({
										maxLength: {
											value: 250,
											message: '',
										},
										pattern: {
											message: translations['common__text__positiveInteger'],
											value: /(?<=\s|^)\d+(?=\s|$)/,
										},
										validate: (value) => isNumber(parseInt(value)),
									})}
									placeholder={
										translations['page__initKiosk__kioskCreation__bankInformations__automateWithContact_padSetting_placeHolder']
									}
								/>
								{errors.withContactSetPad && <ErrorInputMsg>{errors.withContactSetPad.message}</ErrorInputMsg>}
							</InputWrapper>
							{/* Rang / Logique */}
							<LabelText>{`${translations['page__initKiosk__kioskCreation__bankInformations__automateWithContact_rank']}`} :</LabelText>
							<InputWrapper margin={22}>
								<InputLogin
									name="withContactRank"
									width={270}
									type="text"
									disabled={!isEditable}
									ref={register({
										maxLength: {
											value: 250,
											message: '',
										},
										minLength: {
											value: 3,
											message: `3 ${translations['common__text__charMin']}`,
										},
										pattern: {
											message: translations['common__text__positiveInteger'],
											value: /(?<=\s|^)\d+(?=\s|$)/,
										},
										validate: (value) => isNumber(parseInt(value)),
									})}
									placeholder={
										translations['page__initKiosk__kioskCreation__bankInformations__automateWithContact_rank_placeHolder']
									}
								/>
								{errors.withContactRank && <ErrorInputMsg>{errors.withContactRank.message}</ErrorInputMsg>}
							</InputWrapper>
						</FormBody>
					</FormWrapperMiddle>
					<FormWrapperRight>
						<FormTitle>
							<p>{translations['page__initKiosk__kioskCreation__bankInformations__automateWithoutContact_title']}</p>
						</FormTitle>
						<FormBody>
							{/* Numéro Commerçant */}
							<LabelText>
								{`${translations['page__initKiosk__kioskCreation__bankInformations__automateWithoutContact_customerPo']}`} :
							</LabelText>
							<InputWrapper margin={22}>
								<InputLogin
									name="merchantNumber"
									width={270}
									type="text"
									disabled={!isEditable}
									ref={register({
										maxLength: {
											value: 250,
											message: '',
										},
										minLength: {
											value: 7,
											message: `7 ${translations['common__text__charMin']}`,
										},
									})}
									placeholder={
										translations[
											'page__initKiosk__kioskCreation__bankInformations__automateWithoutContact_customerPo_placeHolder'
										]
									}
								/>
								{errors.merchantNumber && <ErrorInputMsg>{errors.merchantNumber.message}</ErrorInputMsg>}
							</InputWrapper>
							{/* Code Banque */}
							<LabelText>
								{`${translations['page__initKiosk__kioskCreation__bankInformations__automateWithoutContact_bankCode']}`} :
							</LabelText>
							<InputWrapper margin={22}>
								<InputLogin
									name="bankCode"
									width={270}
									type="text"
									disabled={!isEditable}
									ref={register({
										maxLength: {
											value: 250,
											message: '',
										},
									})}
									placeholder={
										translations['page__initKiosk__kioskCreation__bankInformations__automateWithoutContact_bankCode_placeHolder']
									}
								/>
								{errors.bankCode && <ErrorInputMsg>{errors.bankCode.message}</ErrorInputMsg>}
							</InputWrapper>
							{/* Numéro de Centre */}
							<LabelText>
								{`${translations['page__initKiosk__kioskCreation__bankInformations__automateWithoutContact_ipAddress']}`} :
							</LabelText>
							<InputWrapper margin={22}>
								<InputLogin
									name="centerNumber"
									width={270}
									type="text"
									disabled={!isEditable}
									ref={register({
										maxLength: {
											value: 250,
											message: '',
										},
									})}
									placeholder={
										translations['page__initKiosk__kioskCreation__bankInformations__automateWithoutContact_ipAddress_placeHolder']
									}
								/>
								{errors.centerNumber && <ErrorInputMsg>{errors.centerNumber.message}</ErrorInputMsg>}
							</InputWrapper>
							{/* PAD de paramétrage */}
							<LabelText>
								{`${translations['page__initKiosk__kioskCreation__bankInformations__automateWithoutContact_padSetting']}`} :
							</LabelText>
							<InputWrapper margin={22}>
								<InputLogin
									name="setPad"
									width={270}
									type="text"
									disabled={!isEditable}
									ref={register({
										maxLength: {
											value: 250,
											message: '',
										},
										pattern: {
											message: translations['common__text__positiveInteger'],
											value: /(?<=\s|^)\d+(?=\s|$)/,
										},
										validate: (value) => isNumber(parseInt(value)),
									})}
									placeholder={
										translations[
											'page__initKiosk__kioskCreation__bankInformations__automateWithoutContact_padSetting_placeHolder'
										]
									}
								/>
								{errors.setPad && <ErrorInputMsg>{errors.setPad.message}</ErrorInputMsg>}
							</InputWrapper>
							{/* Rang / Logique */}
							<LabelText>
								{`${translations['page__initKiosk__kioskCreation__bankInformations__automateWithoutContact_rank']}`} :
							</LabelText>
							<InputWrapper margin={22}>
								<InputLogin
									name="rank"
									width={270}
									type="text"
									disabled={!isEditable}
									ref={register({
										maxLength: {
											value: 250,
											message: '',
										},
										minLength: {
											value: 3,
											message: `3 ${translations['common__text__charMin']}`,
										},
										pattern: {
											message: translations['common__text__positiveInteger'],
											value: /(?<=\s|^)\d+(?=\s|$)/,
										},
										validate: (value) => isNumber(parseInt(value)),
									})}
									placeholder={
										translations['page__initKiosk__kioskCreation__bankInformations__automateWithoutContact_rank_placeHolder']
									}
								/>
								{errors.rank && <ErrorInputMsg>{errors.rank.message}</ErrorInputMsg>}
							</InputWrapper>
						</FormBody>
					</FormWrapperRight>
				</KioskBankDetailColumnWrapper>
			</FormWrapper>
		</KioskBankDetailsWrapper>
	)
}

KioskBankDetails.propTypes = {}

KioskBankDetails.defaultPropTypes = {}

export default KioskBankDetails
